import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Normalize duplicate slashes in URL while preserving protocol (e.g., https://)
    const originalUrl = request.url;
    const normalizedUrl = originalUrl.replace(/([^:]\/)\/+/g, '$1');

    if (normalizedUrl !== originalUrl) {
      console.warn('[HTTP] Normalized URL:', originalUrl, '→', normalizedUrl);
      request = request.clone({ url: normalizedUrl });
    }

    console.log('Outgoing request to:', request.url);

    return next.handle(request).pipe(
      catchError((err: any) => {
        console.error('Caught error in LoggingInterceptor:', err);

        if (err instanceof HttpErrorResponse) {
          let errorMessage = '';
          if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred.
            errorMessage = `Client-side error: ${err.error.message}`;
          } else {
            // The backend returned an unsuccessful response code.
            errorMessage = `Server-side error: ${err.status} ${err.statusText}. Body: ${JSON.stringify(err.error)}`;
          }
          console.error(errorMessage);
        } else {
          console.error('Error in interceptor is not an HttpErrorResponse:', err);
        }

        return throwError(() => err);
      })
    );
  }
}